module.exports = function tryRemoveDuplicateEvents(externalEvents, tripEvents) {
	var events = tryRemoveDuplicateExternalEvents(externalEvents);
	events = tryRemoveDuplicateTripEvents(events, tripEvents);
	return events;
};

function tryRemoveDuplicateExternalEvents(externalEvents) {
	var uniqueEvents = [];
	for(var event of externalEvents) {
		var duplicateEvent = uniqueEvents.find(x => x.place == event.place);
		if(duplicateEvent){
			if(duplicateEvent.url) continue;
			var indexOfDuplicate = uniqueEvents.indexOf(duplicateEvent);
			uniqueEvents[indexOfDuplicate] = event;
			continue;
		}

		uniqueEvents.push(event);
	}

	return uniqueEvents;
}

function tryRemoveDuplicateTripEvents(externalEvents, tripEvents) {
	for (var i = 0; i < externalEvents.length; i++) {
		var tripEventsLength = tripEvents.length - 1;

		for (var j = tripEventsLength; j >= 0; j--) {
			if(tripEvents[j].name !== undefined && externalEvents[i].place !== undefined && externalEvents[i].place.indexOf(tripEvents[j].name) !== -1){
				tripEvents.splice(j, 1);
			}
		}
	}

	return externalEvents.concat(tripEvents);
}